// Created by PeakXin on 2025/10/29.
import request from '@/utils/request'

export function getUserInfo() {
  return request({
    url: '/v1/member/show',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/vue-admin-template/user/logout',
    method: 'post'
  })
}

export function getAgentInfo() {
  return request({
    url: '/v1/3d-vision/agent/detail',
    method: 'get'
  })
}
